import { render } from "./BaseCartEmpty.vue?vue&type=template&id=7a49cdfe&scoped=true"
import script from "./BaseCartEmpty.vue?vue&type=script&lang=js"
export * from "./BaseCartEmpty.vue?vue&type=script&lang=js"

import "./BaseCartEmpty.vue?vue&type=style&index=0&id=7a49cdfe&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a49cdfe"]])

export default __exports__